// extracted by mini-css-extract-plugin
module.exports = {"button":"_mm","primary":"_mn","disabled":"_mo"};